import React from "react";
import { QueryRenderer } from "@cubejs-client/react";
import { Spin } from "antd";
import { AutoComplete } from "antd";
import cubejsApi from "../../cubejsApiBQ";

const aseguradoras = ({ resultSet, props }) => {
    var dataSource = [];
    var aseguradora = "";
    resultSet.loadResponse.data.map((result, index) => {
        return (dataSource[index] = result["ResumenCp.aseguradora"]);
    });
    if (props.cargo) {
        aseguradora = dataSource[dataSource.indexOf(props.nombre)];
    }
    return (
        <AutoComplete
            style={{
                width: "100%",
                marginBottom: "25px",
            }}
            disabled={props.cargo || true}
            allowClear
            size="large"
            //   dataSource={dataSource}
            placeholder="Aseguradora"
            defaultValue={aseguradora}
            filterOption={(inputValue, option) => {
                return (
                    option.props.children
                        .toUpperCase()
                        .indexOf(inputValue.toUpperCase()) !== -1
                );
            }}
            //   onSelect={value => null}
            //   onSearch={() => null}
        />
    );
};

const renderChart = (Component, props) => ({ resultSet, error }) =>
    (resultSet && <Component resultSet={resultSet} props={props} />) || (
        <Spin />
    );

const Aseguradoras = (props) => (
    <QueryRenderer
        query={{
            renewQuery: true,
            measures: [],
            timeDimensions: [],
            dimensions: ["ResumenCp.aseguradora"],
            segments: [],
            filters: [
                {
                    dimension: "Usuarios.zona",
                    operator: "contains",
                    values: props.zona !== "" ? [props.zona] : [],
                },
            ],
        }}
        cubejsApi={cubejsApi}
        render={renderChart(aseguradoras, props)}
    />
);

export default Aseguradoras;
